// extracted by mini-css-extract-plugin
var _1 = "q8ZmvZZh";
var _2 = "q8ZmvZZh";
export { _1 as "sustainable-corner", _2 as "sustainableCorner" }
